import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useRenameStudy(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation(
    async ({
      gameId,
      name,
      description,
    }: {
      gameId: string;
      name?: string;
      description?: string;
    }) => {
      const payload: {name?: string; description?: string} = {};
      if (name !== undefined) payload.name = name;
      if (description !== undefined) payload.description = description;
      const response = await ChessRestClient.post(
        `learning/study_games/${gameId}/rename/`,
        payload,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
